/**
 * KPI Card and Metric Card components for analytics views
 */

// KPI Card Component
export function KPICard({ icon, label, value, sublabel, color = 'orange' }) {
  return (
    <div className={`analytics-kpi-card analytics-kpi-card--${color}`}>
      <div className="kpi-icon">{icon}</div>
      <div className="kpi-content">
        <span className="kpi-value">{value}</span>
        <span className="kpi-label">{label}</span>
        {sublabel && <span className="kpi-sublabel">{sublabel}</span>}
      </div>
    </div>
  );
}

// Metric Card Component
export function MetricCard({ title, metrics }) {
  return (
    <div className="analytics-metric-card">
      <div className="metric-card-header">
        <h4>{title}</h4>
      </div>
      <div className="metric-card-content">
        {metrics.map((metric, idx) => (
          <div key={idx} className={`metric-row ${metric.warning ? 'metric-row--warning' : ''}`}>
            <span className="metric-label">{metric.label}</span>
            <span className="metric-value">{metric.value}</span>
          </div>
        ))}
        {metrics.length === 0 && (
          <div className="metric-row metric-row--empty">
            <span className="metric-label">Keine Daten</span>
          </div>
        )}
      </div>
    </div>
  );
}
